<template>
  <div>

    <!-- 头部 -->
    <top></top>
    <!-- logo -->
    <div class="logo">
      <img
        v-if="bannerArr.length > 0"
        class="banner"
        :src="$imgUrl+bannerArr[0].thumb"
        alt=""
      />
    </div>
    <!-- <vue-markdown :source="markdownContent"></vue-markdown> -->
    <div class="container">
      <div
        class="contact_item"
        v-for="(item, index) in contactsLists"
        :key="index"
      >
        <div class="contact_title">
          {{ langSet == "cn" ? item.title : item.en_title }}
        </div>
        <div class="contact_content">
          <div v-html="langSet == 'cn' ? item.content : item.en_content"></div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";

// import VueMarkdown from 'vue-markdown'
import { getBanner, getContactsLists } from "@/api/api";

export default {
  components: { top, bottom },
  name: "home",
  // 配置title和meta数据
  metaInfo() {
    return {
      title:this.langSet=='cn'?this.keydata.name_cn:this.keydata.name_en,
      meta: [
        {
          name: "description",
          content: this.keydata.description,
        },
        {
          name: "keywords",
          content: this.keydata.keywords,
        },
      ],
    };
  },
  data() {
    return {
      langSet: "",
      bannerArr: [],
      contactsLists: [],
      keydata:{}
      //       markdownContent: `## 从首都机场抵达展馆
      // ![image](https://note.youdao.com/favicon.ico)
      // - 驾车：从首都机场--S12机场告诉---天北路，车程6.4公里，用时约30分钟，相距约6.4公里。
      // - 地铁：咋安吾合适的的地图铁路线`
    };
  },
  created() {},
  activated(){
     let menuArr=JSON.parse(localStorage.getItem('menuArr'))
     menuArr.map(item=>{
       if(item.name_cn=='联系我们'||item.name_en=='Contact us'){
            console.log(item,"item")
            this.keydata=item;
            
       }
     })
    
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getBannerList();
    this.getContacts();
  },
  methods: {
    // zhang 获取关于展会banner
    getBannerList() {
      let data = {
        class: "资料下载",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 联系我们
    getContacts() {
      let data = {};
      getContactsLists(data)
        .then((res) => {
          if (res.code == 1) {
            this.contactsLists = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  width: 100%;
  height: 400px;
  img {
    width: 100%;
    height: 400px;
  }
}
.container {
  display: flex;
  justify-content: space-between;
  margin: 50px auto 76px;
  background: rgba(171, 181, 205, 0.1);
  padding: 50px;
  box-sizing: border-box;
  .contact_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #2c2c2e;
    margin-bottom: 20px;
  }
  .contact_content {
    width: 580px;
    padding: 30px 25px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 20px;
    .conmpany_right_title {
      display: inline-block;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #2c2c2e;
      border-bottom: 2px solid #243889;
      line-height: 25px;
      height: 25px;
      margin-right: 20px;
      margin-bottom: 10px;
    }
    .conmpany_bottom {
      margin-bottom: 20px;
    }
    .conmpany_right_contents {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #2c2c2e;
      line-height: 25px;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .container {
    width: 90%;
    .contact_item {
      width: 100%;
      .contact_content {
        width: 95% !important;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .container {
    display: inline-block;
    background: #fff;
    margin: 50px auto !important;
    padding: 0 20px !important;
    .contact_content {
      width: 100% !important;
      padding: 0 !important;
    }
  }
  .contact_item:nth-child(2) {
    margin-top: 50px !important;
  }
  .logo {
    margin-top: 0.88rem;
    height: 81px !important;
    img {
      height: 81px !important;
    }
  }
}
</style>